export default {"src":"/_next/static/media/mastercard.50dbf532.svg","height":50,"width":50};